exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (max-width: 762px) {\n  .cellButtonContainer__Transport_1_takeout-module___1b1Qz {\n    margin-top: 26px;\n  }\n  .cell__Transport_1_takeout-module___IAfl0 {\n    padding-bottom: 12px;\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"cellButtonContainer": "cellButtonContainer__Transport_1_takeout-module___1b1Qz",
	"cell": "cell__Transport_1_takeout-module___IAfl0"
};